export const scrollToTooltipFix = () => {
  document.body.style.height = 'unset';
  document
    .querySelector('#app-site')
    ?.setAttribute('style', 'min-height: 100vh;height: 100%;position: unset;');
};

export const scrollToTooltipFixRevert = () => {
  document.body.style.height = '100%';
  document.querySelector('#app-site')?.setAttribute('style', 'height: 100vh;position: fixed;');
};
